export const nonAdminPages = [
  'email_sent',
  'first_time',
  'home',
  'login',
  'need_help',
  'reset_email_sent',
  'set_password',
  'test_page',
  'no_tenant',
  'welcome',
  'dsconnected',
  'dssigned'
];
